<div class="dynamic-field" [formGroup]="group">
  <label for="orthophotomapSelect">{{ config.label }}</label>
  <select
    id="orthophotomapSelect"
    class="form-select"
    [formControlName]="config.name"
    >
    @for (option of options; track option) {
      <option [value]="option.value">
        {{ option.releaseYear }} {{ option.composition }}
      </option>
    }
  </select>
  <gk-form-control-validation
    [formGroup]="group"
    [fieldConfig]="config"
    [submitted]="submitted"
  ></gk-form-control-validation>
</div>
